import React from 'react';
import { Container } from "react-bootstrap";
import MyReactMapComponent from "../components/MyReactMapComponent"; // Используем контейнер из Bootstrap


const InfoPage = () => {
    return (
        <>
            <Container className="info-page-content">
                <h1 className="text-center mb-4">Контактная информация и Документы</h1>

                <section className="mb-5">
                    <h2 className="text-center mb-3">Телефоны</h2>
                    <div className="phone-box green-background">
                        <div className="contact-info-block text-center">
                            <p className="contact-text">Телефон - Бесплатная линия:</p>
                            <p className="phone-number-text"> 8-800-505-56-77</p>
                            <p className="contact-text mt-3">WhatsApp - пишите:</p>
                            <p className="whatsapp-number-text">8-928-310-25-33</p>
                            <p className="contact-text mt-3">MAX - пишите:</p>
                            <p className="whatsapp-number-text">8-928-310-25-33</p>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center flex-column text-center align-items-center">
                    <div className="documents">Документы, необходимые для заезда:</div>
                        <div>
                            <p>Расчетный час: время заезда в 14:00, время выезда в 12:00.</p>
                            <p><b>Взрослым:</b></p>
                            <p>Санаторно-курортная карта (выданная не ранее 1 месяца до даты заезда в санаторий);</p>
                            <p>Беременные женщины принимаются в санаторий только при наличии санаторно-курортной карты,
                                с
                                заключением врача гинеколога по месту жительства с указанием диагноза и сроков
                                беременности,
                                показаниями и противопоказаниями к санаторно-курортному лечению;</p>
                            <p>Паспорт;</p>
                            <p>Страховой полис ОМС или ДМС;</p>
                            <br/>
                            <p><b>Детям:</b></p>
                            <p>Свидетельство о рождении;</p>
                            <p>Санаторно-курортная карта (давностью не более 1 месяца от даты получения);</p>
                            <p>Анализ на энтеробиоз (давностью не более 2 месяцев от даты получения);</p>
                            <p>Заключение врача-дерматолога об отсутствии кожных заболеваний;</p>
                            <p>Справка о прививках;</p>
                            <p>Справка об эпидокружении (давностью не более 3 дней от даты получения);</p>
                            <p>Страховой полис ОМС или ДМС;</p>
                        </div>
                    </div>
                </section>

                <section className="mb-5">
                    <h2 className="text-center mb-3">Адрес</h2>
                    <p className="text-center mb-4">
                        г. Кисловодск, улица Профинтерна, 50
                    </p>
                    <div className="map-container">
                        <div style={{ width: '100%', height: '100%', backgroundColor: '#eee', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '1.2em', color: '#666' }}>
                            <MyReactMapComponent/>
                        </div>
                    </div>
                </section>

                <section className="mb-3"> {/* mb-5 из Bootstrap */}
                    <h2 className="text-center mb-3">Документы</h2> {/* text-center и mb-3 из Bootstrap */}
                    <ul className="list-unstyled text-center">
                        <li className="mb-2">
                            <a href="../Assets/agreement11.pdf" target="_blank" rel="noopener noreferrer">Политика конфиденциальности</a> {/* <-- ЗАМЕНИ */}
                        </li>
                    </ul>
                    <p>Вся информация, размещённая на сайте, носит исключительно информационный характер и ни при каких условиях не является публичной офертой,
                        определяемой положениями статьи 437 Гражданского кодекса Российской Федерации.
                        Для расчёта окончательной стоимости путёвки обращайтесь к менеджерам по контактам, указанным на сайте, или отправьте заявку через форму обратной связи.
                        Сайт принадлежит ИП Князев Ю.В., ИНН 262800735241, ОГРНИП 304262821800050, и является сайтом партнёра санатория «Родник» в г. Кисловодске.
                        Сайт не является официальным сайтом санатория.</p>
                </section>
            </Container>
        </>
    );
};

export default InfoPage;